export class LivingExpenseModel{
  id: number;
  manageEngineId: number;
  reasonType: string;
  reasonCode: string;
  description: string;
  provideReason: boolean;
  createdOn: Date;
  createdBy: string;
  updatedOn: Date;
  updatedBy: string;
}

